import React, { CSSProperties } from "react";
import RichText from "../StringHtmlToReact";
import "./styles.scss";
import utils from "../TossUpChallenge/code/js/utils";
export const generatedGiveAwayId = (giveaway: string) =>
  `${giveaway}_how_to_play`;

const HowToPlay: React.FC<any> = ({
  giveaway,
  title,
  titleColor,
  descriptionColor,
  backgroundImage,
  backgroundImageAsInner,
  tuneInTitle,
  tuneInDescription,
  enterTitle,
  enterDescription,
  returnTitle,
  returnDescription,
  mobilebackground,
  mobilebackgroundAsInner,
  joinOrLoginTitle,
  joinOrLoginDescription,
}) => {
  const bgStyle: CSSProperties = {};
  let hasbgImage = Boolean(backgroundImage);

  if (hasbgImage) {
    bgStyle.backgroundImage = `url("${backgroundImage}")`;
  }
  if (utils.device_detect() === "mobile") {
    bgStyle.backgroundImage = `url("${mobilebackground}")`;
  } else {
    bgStyle.backgroundImage = `url("${backgroundImage}")`;
  }

  const renderItem: React.FC<any> = (title, desc) => (
    <div
      className={
        "item col-xs-12 " + (joinOrLoginTitle ? "col-md-6" : "col-md-4")
      }
    >
      <h3 className="subtitle" style={{ color: titleColor }}>
        {title}
      </h3>
      <div className="description" style={{ color: descriptionColor }}>
        <RichText stringHtml={desc} />
      </div>
    </div>
  );

  return (
    <div id={generatedGiveAwayId(giveaway)} className="giveaways-htp">
      {
        <>
          {backgroundImageAsInner ?
            <style
            dangerouslySetInnerHTML=
            {{
              __html: `
              .how-to-play-bg .row.inner-content{
                background-image: url("${backgroundImage}")
              }`
            }} />
            :
            <style
            dangerouslySetInnerHTML=
            {{
              __html: `
              .how-to-play-bg{
                background-image: url("${backgroundImage}")
              }`
            }} />
          }
          {mobilebackgroundAsInner ?
            <style
            dangerouslySetInnerHTML=
            {{
              __html: `
              @media (min-width: 320px) and (max-width: 767px) {
                .how-to-play-bg .row.inner-content{
                  background-image: url("${mobilebackground}")
              }`
            }} />
            :
            <style
            dangerouslySetInnerHTML=
            {{
              __html: `
              @media (min-width: 320px) and (max-width: 767px) {
                .how-to-play-bg{
                  background-image: url("${mobilebackground}")
              }`
            }} />
          }
        </>
      }
      <div
        className={
          "container how-to-play-bg " + (joinOrLoginTitle ? "join_login" : "")
        }
      >
        <div className="row">
          <div className="col-12">
            <h1 className="title" style={{ color: titleColor }}>
              {title}
            </h1>
          </div>
        </div>
        <div className="row inner-content">
          {renderItem(tuneInTitle, tuneInDescription)}
          {renderItem(enterTitle, enterDescription)}

          {joinOrLoginTitle
            ? renderItem(joinOrLoginTitle, joinOrLoginDescription)
            : null}
          {renderItem(returnTitle, returnDescription)}
        </div>
      </div>
    </div>
  );
};

export default HowToPlay;
